export default __webpack_public_path__ + "static/media/10_zahon-ve-skolce.9f9a2f9b.jpg";